/* Core / critical JS only - loaded on every page for rendering priority elements */
/* Keep it as small as possible! */

/* global gsap */

function CookiebotCallback_OnAccept() {
    Cookiebot.changed && document.location.reload();
}

document.addEventListener("DOMContentLoaded", function (event) {

    const openMenuButton = document.getElementById("open-menu-button");
    const closeMenuButton = document.getElementById("close-menu-button");
    const mobileNavMenu = document.getElementById("mobile-nav-menu");
    const navOverlay = document.getElementById("mobile-nav-background-overlay");
    let openMenuTL = gsap.timeline();
    let closeMenuTL = gsap.timeline();

    const openMenu = () => {
        mobileNavMenu.classList.add("active");
        openMenuTL
            .to(navOverlay, {right: "0", duration: 0})
            .to(navOverlay, {opacity: "0.4", duration: 1})
            .to(mobileNavMenu, {right: "0"}, "<")
    }

    openMenuButton.addEventListener('click', openMenu, false);

    const closeMenu = () => {
        let calculateWidth = mobileNavMenu.offsetWidth;
        mobileNavMenu.classList.remove("active");
        closeMenuTL
            .to(navOverlay, {opacity: "0", duration: 0.2})
            .to(navOverlay, {right: "-100vw", duration: 0})
            .to(mobileNavMenu, {right: calculateWidth * -1}, "<")
    }

    closeMenuButton.addEventListener('click', closeMenu, false);

    let lastScrollTop = 0;
    const navigation = document.getElementById("navigation");

    window.addEventListener("scroll", function () {
        let st = window.pageYOffset || document.documentElement.scrollTop;

        if (st === 0) {
            navigation.classList.remove('scrolling');
            navigation.classList.add('nav-at-top');
        } else {
            navigation.classList.remove('nav-at-top');
        }

        if (st > lastScrollTop) {
            // downscroll code
            navigation.classList.add('scrolling');
        } else {
            // upscroll code
            navigation.classList.remove('scrolling');
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);

    window.dispatchEvent(new CustomEvent('scroll'));

    let openMobileNavDropdownElements = document.getElementsByClassName('mobile-nav-dropdown-open');
    let openMobileNavDropdown = function () {
        this.parentElement.classList.add('open');
    };
    for (let i = 0; i < openMobileNavDropdownElements.length; i++) {
        openMobileNavDropdownElements[i].addEventListener('click', openMobileNavDropdown, false);
    }

    let closeMobileNavDropdownElements = document.getElementsByClassName('mobile-nav-dropdown-close');
    let closeMobileNavDropdown = function () {
        this.parentElement.classList.remove('open');
    };
    for (let i = 0; i < closeMobileNavDropdownElements.length; i++) {
        closeMobileNavDropdownElements[i].addEventListener('click', closeMobileNavDropdown, false);
    }
});





